// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/plus-jakarta-sans-v11-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/plus-jakarta-sans-v11-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/plus-jakarta-sans-v11-latin-800.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --page-padding: clamp(1.25rem, 5.5vw, 5rem);
  --section-max-width: 70rem;

  --primary-color: #13183f;
  --primary-color-light: #666ca3;

  --accent-color: #f74780;
  --accent-color-light: #ffa7c3;

  --header-text-color: var(--primary-color);
  --header-text-color-light: #ffffff;

  --body-text-color: #83869a;
  --body-text-color-light: #ffffff;

  --gradient-pink: linear-gradient(180deg, #ff6f48 0%, #f02aa6 100%);
  --gradient-purple: linear-gradient(180deg, #4851ff 0%, #f02aa6 100%);

  --card-shadow: box-shadow: 0px 25px 50px rgba(6, 22, 141, 0.0442381);
}

/* ******************* */
/*        RESETS       */
/* ******************* */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
}

a {
  text-decoration: none;
}

li {
  list-style: none;
}

/* ******************* */
/*      COMPONENTS     */
/* ******************* */

.button-solid {
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--body-text-color-light);
  padding: 1rem 2rem;
  border-radius: 28px;
  font-size: 1rem;
  font-weight: bold;
}

.button-solid:hover {
  opacity: 0.9;
}

@media only screen and (min-width: 48rem) {
  .button-solid {
    padding: 0.75rem 1.5rem;
  }
}
/* ******************* */
/*    GLOBAL STYLING   */
/* ******************* */

body {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header,
main,
footer {
  flex: 0 0 auto;
  .container {
    max-width: var(--section-max-width);
    margin: 0 auto;
  }
}

main {
  flex-grow: 1;
}

header,
footer,
section {
  padding: 0 var(--page-padding);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--header-text-color);
}

p,
a {
  color: var(--body-text-color);
}

.logo-container a {
  display: block;
  height: 1.25rem;
  width: 79.29px;

  img {
    width: 100%;
  }
}

@media only screen and (min-width: 64rem) {
  .logo-container a {
    height: 1.75rem;
    width: 111px;
  }
}
/* ******************* */
/*         FONTS       */
/* ******************* */
/* plus-jakarta-sans-500 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* plus-jakarta-sans-700 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* plus-jakarta-sans-800 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* ******************* */
/*      TYPOGRAPHY     */
/* ******************* */
.textpreset1 {
  font-size: 40px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 900;
  line-height: 120%;
}

.textpreset2 {
  font-size: 32px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 900;
  line-height: 120%;
}

.textpreset3 {
  font-size: 24px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 900;
  line-height: 120%;
}

.textpreset4 {
  font-size: 20px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 900;
  line-height: 120%;
}

.textpreset5 {
  font-size: 18px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 500;
  line-height: 150%;
}

.textpreset6 {
  font-size: 16px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 700;
  line-height: 150%;
}

.textpreset7 {
  font-size: 18px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 700;
  line-height: 150%;
}

@media only screen and (min-width: 64rem) {
  .textpreset1 {
    font-size: 56px;
  }

  .textpreset2 {
    font-size: 40px;
  }

  .textpreset3 {
    font-size: 32px;
  }
  .textpreset4 {
    font-size: 24px;
  }

  .textpreset6 {
    font-size: 16px;
    line-height: 150%;
  }
}

/* ******************* */
/*       HEADER        */
/* ******************* */
header {
  & > .container {
    padding: 1rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
}

@media only screen and (min-width: 48rem) {
  header {
    overflow: hidden;
    padding: 0 calc(var(--page-padding) + 1.76px);
    z-index: 1;
    & > .container {
      padding: 1.5rem 0;
    }
  }
}

@media only screen and (min-width: 64rem) {
  header {
    padding: 0 calc(var(--page-padding) + 0.8px);
  }
}

/* ******************* */
/*         HERO        */
/* ******************* */

#hero {
  text-align: start;
  padding: 4rem calc(var(--page-padding) - 0.625px);

  .container,
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 1.5rem;
  }

  p {
    width: 100%;
    max-width: clamp(45ch, 1rem + 60vw, 66ch);
    margin-bottom: calc(40px - 1.5rem);
  }

  a.button-solid {
    background: var(--gradient-pink);
  }

  .image-container {
    margin: 0 auto;
  }

  picture,
  img {
    width: 100%;
    height: auto;
  }
}

/* Tablet */
@media only screen and (min-width: 48rem) {
  #hero {
    padding: 4rem calc(var(--page-padding) + 1.76px);
    .container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center;
      position: relative;
    }

    .image-container {
      position: relative;
      left: 80px;
      transform: translateY(-100px);
    }

    img {
      width: 140%;
    }
  }
}

/* Desktop */
@media only screen and (min-width: 64rem) {
  #hero {
    padding-left: calc(var(--page-padding) + 0.8px);
    padding-right: calc(var(--page-padding) + 0.8px);

    .container {
      position: relative;
      gap: 2rem;
    }

    p {
      max-width: 35ch;
    }

    .image-container {
      position: relative;
      left: 5%;
      bottom: 25%;
      max-height: 35rem;
    }
    img {
      width: 170%;
    }
  }
}

/* ******************* */
/*       FOOTER        */
/* ******************* */

footer {
  padding: 1.5rem var(--page-padding);
  background-color: var(--primary-color);

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  a.button-solid {
    padding: 0.75rem 1.5rem;
    background: var(--gradient-purple);
  }
}

/* TABLET */
@media only screen and (min-width: 48rem) {
  footer {
    padding: 1.5rem calc(var(--page-padding) + 1.76px);
  }
}

/* DESKTOP */
@media only screen and (min-width: 64rem) {
  footer {
    padding-left: calc(var(--page-padding) + 0.69px);
    padding-right: calc(var(--page-padding) + 0.69px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,0BAA0B;;EAE1B,wBAAwB;EACxB,8BAA8B;;EAE9B,uBAAuB;EACvB,6BAA6B;;EAE7B,yCAAyC;EACzC,kCAAkC;;EAElC,0BAA0B;EAC1B,gCAAgC;;EAEhC,kEAAkE;EAClE,oEAAoE;;EAEpE,oEAAoE;AACtE;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,qBAAqB;EACrB,sCAAsC;EACtC,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd;IACE,mCAAmC;IACnC,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;;EAEd;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;AACA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB,kCAAkC;AAClC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB,EAAE,4DAA4D;AACjF;AACA,kCAAkC;AAClC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB,EAAE,4DAA4D;AACjF;AACA,kCAAkC;AAClC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB,EAAE,4DAA4D;AACjF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,6CAA6C;IAC7C,UAAU;IACV;MACE,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,iDAAiD;;EAEjD;;IAEE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yCAAyC;IACzC,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE;IACE,gDAAgD;IAChD;MACE,aAAa;MACb,qCAAqC;MACrC,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,6BAA6B;IAC/B;;IAEA;MACE,WAAW;IACb;EACF;AACF;;AAEA,YAAY;AACZ;EACE;IACE,+CAA+C;IAC/C,gDAAgD;;IAEhD;MACE,kBAAkB;MAClB,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,WAAW;MACX,iBAAiB;IACnB;IACA;MACE,WAAW;IACb;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,mCAAmC;EACnC,sCAAsC;;EAEtC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,kCAAkC;EACpC;AACF;;AAEA,WAAW;AACX;EACE;IACE,kDAAkD;EACpD;AACF;;AAEA,YAAY;AACZ;EACE;IACE,gDAAgD;IAChD,iDAAiD;EACnD;AACF","sourcesContent":[":root {\n  --page-padding: clamp(1.25rem, 5.5vw, 5rem);\n  --section-max-width: 70rem;\n\n  --primary-color: #13183f;\n  --primary-color-light: #666ca3;\n\n  --accent-color: #f74780;\n  --accent-color-light: #ffa7c3;\n\n  --header-text-color: var(--primary-color);\n  --header-text-color-light: #ffffff;\n\n  --body-text-color: #83869a;\n  --body-text-color-light: #ffffff;\n\n  --gradient-pink: linear-gradient(180deg, #ff6f48 0%, #f02aa6 100%);\n  --gradient-purple: linear-gradient(180deg, #4851ff 0%, #f02aa6 100%);\n\n  --card-shadow: box-shadow: 0px 25px 50px rgba(6, 22, 141, 0.0442381);\n}\n\n/* ******************* */\n/*        RESETS       */\n/* ******************* */\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\na {\n  text-decoration: none;\n}\n\nli {\n  list-style: none;\n}\n\n/* ******************* */\n/*      COMPONENTS     */\n/* ******************* */\n\n.button-solid {\n  display: inline-block;\n  background-color: var(--primary-color);\n  color: var(--body-text-color-light);\n  padding: 1rem 2rem;\n  border-radius: 28px;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.button-solid:hover {\n  opacity: 0.9;\n}\n\n@media only screen and (min-width: 48rem) {\n  .button-solid {\n    padding: 0.75rem 1.5rem;\n  }\n}\n/* ******************* */\n/*    GLOBAL STYLING   */\n/* ******************* */\n\nbody {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nheader,\nmain,\nfooter {\n  flex: 0 0 auto;\n  .container {\n    max-width: var(--section-max-width);\n    margin: 0 auto;\n  }\n}\n\nmain {\n  flex-grow: 1;\n}\n\nheader,\nfooter,\nsection {\n  padding: 0 var(--page-padding);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: var(--header-text-color);\n}\n\np,\na {\n  color: var(--body-text-color);\n}\n\n.logo-container a {\n  display: block;\n  height: 1.25rem;\n  width: 79.29px;\n\n  img {\n    width: 100%;\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  .logo-container a {\n    height: 1.75rem;\n    width: 111px;\n  }\n}\n/* ******************* */\n/*         FONTS       */\n/* ******************* */\n/* plus-jakarta-sans-500 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Plus Jakarta Sans\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"./assets/fonts/plus-jakarta-sans-v11-latin-500.woff2\")\n    format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* plus-jakarta-sans-700 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Plus Jakarta Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"./assets/fonts/plus-jakarta-sans-v11-latin-700.woff2\")\n    format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* plus-jakarta-sans-800 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Plus Jakarta Sans\";\n  font-style: normal;\n  font-weight: 800;\n  src: url(\"./assets/fonts/plus-jakarta-sans-v11-latin-800.woff2\")\n    format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n\n/* ******************* */\n/*      TYPOGRAPHY     */\n/* ******************* */\n.textpreset1 {\n  font-size: 40px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 900;\n  line-height: 120%;\n}\n\n.textpreset2 {\n  font-size: 32px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 900;\n  line-height: 120%;\n}\n\n.textpreset3 {\n  font-size: 24px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 900;\n  line-height: 120%;\n}\n\n.textpreset4 {\n  font-size: 20px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 900;\n  line-height: 120%;\n}\n\n.textpreset5 {\n  font-size: 18px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n.textpreset6 {\n  font-size: 16px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n.textpreset7 {\n  font-size: 18px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n@media only screen and (min-width: 64rem) {\n  .textpreset1 {\n    font-size: 56px;\n  }\n\n  .textpreset2 {\n    font-size: 40px;\n  }\n\n  .textpreset3 {\n    font-size: 32px;\n  }\n  .textpreset4 {\n    font-size: 24px;\n  }\n\n  .textpreset6 {\n    font-size: 16px;\n    line-height: 150%;\n  }\n}\n\n/* ******************* */\n/*       HEADER        */\n/* ******************* */\nheader {\n  & > .container {\n    padding: 1rem 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n  }\n}\n\n@media only screen and (min-width: 48rem) {\n  header {\n    overflow: hidden;\n    padding: 0 calc(var(--page-padding) + 1.76px);\n    z-index: 1;\n    & > .container {\n      padding: 1.5rem 0;\n    }\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  header {\n    padding: 0 calc(var(--page-padding) + 0.8px);\n  }\n}\n\n/* ******************* */\n/*         HERO        */\n/* ******************* */\n\n#hero {\n  text-align: start;\n  padding: 4rem calc(var(--page-padding) - 0.625px);\n\n  .container,\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 1.5rem;\n  }\n\n  p {\n    width: 100%;\n    max-width: clamp(45ch, 1rem + 60vw, 66ch);\n    margin-bottom: calc(40px - 1.5rem);\n  }\n\n  a.button-solid {\n    background: var(--gradient-pink);\n  }\n\n  .image-container {\n    margin: 0 auto;\n  }\n\n  picture,\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n/* Tablet */\n@media only screen and (min-width: 48rem) {\n  #hero {\n    padding: 4rem calc(var(--page-padding) + 1.76px);\n    .container {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      align-items: center;\n      position: relative;\n    }\n\n    .image-container {\n      position: relative;\n      left: 80px;\n      transform: translateY(-100px);\n    }\n\n    img {\n      width: 140%;\n    }\n  }\n}\n\n/* Desktop */\n@media only screen and (min-width: 64rem) {\n  #hero {\n    padding-left: calc(var(--page-padding) + 0.8px);\n    padding-right: calc(var(--page-padding) + 0.8px);\n\n    .container {\n      position: relative;\n      gap: 2rem;\n    }\n\n    p {\n      max-width: 35ch;\n    }\n\n    .image-container {\n      position: relative;\n      left: 5%;\n      bottom: 25%;\n      max-height: 35rem;\n    }\n    img {\n      width: 170%;\n    }\n  }\n}\n\n/* ******************* */\n/*       FOOTER        */\n/* ******************* */\n\nfooter {\n  padding: 1.5rem var(--page-padding);\n  background-color: var(--primary-color);\n\n  .container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  a.button-solid {\n    padding: 0.75rem 1.5rem;\n    background: var(--gradient-purple);\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 48rem) {\n  footer {\n    padding: 1.5rem calc(var(--page-padding) + 1.76px);\n  }\n}\n\n/* DESKTOP */\n@media only screen and (min-width: 64rem) {\n  footer {\n    padding-left: calc(var(--page-padding) + 0.69px);\n    padding-right: calc(var(--page-padding) + 0.69px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
